var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBrowseIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.58579 6.58579C4.21071 6.96086 4 7.46957 4 8V15.5C4 15.8978 4.15804 16.2794 4.43934 16.5607C4.72064 16.842 5.10218 17 5.5 17C5.89782 17 6.27936 16.842 6.56066 16.5607C6.84196 16.2794 7 15.8978 7 15.5V14C7 13.2044 7.31607 12.4413 7.87868 11.8787C8.44129 11.3161 9.20435 11 10 11H18V10C18 9.46957 17.7893 8.96086 17.4142 8.58579C17.0391 8.21071 16.5304 8 16 8H12L10 6H6C5.46957 6 4.96086 6.21071 4.58579 6.58579Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.58579 12.5858C8.21071 12.9609 8 13.4696 8 14V16C8 16.5304 7.78929 17.0391 7.41421 17.4142C7.03914 17.7893 6.53043 18 6 18H18C18.5304 18 19.0391 17.7893 19.4142 17.4142C19.7893 17.0391 20 16.5304 20 16V14C20 13.4696 19.7893 12.9609 19.4142 12.5858C19.0391 12.2107 18.5304 12 18 12H10C9.46957 12 8.96086 12.2107 8.58579 12.5858Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBrowseIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/browse-icon.d0708befaf2caff94b46c0c349a90ebd.svg";